module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', {
    staticClass: "s-actionsheet"
  }, [_c('c-content', [_c('div', {
    staticClass: "industry-container"
  }, [_c('div', {
    staticClass: "sales-item-block"
  }, [(_vm.userInfo.saasOrderCount <= 0) ? _c('div', {
    staticClass: "ds-flex sales-item item-one"
  }, [_c('div', {
    staticClass: "item-header"
  }, [_c('div', {
    staticClass: "text-color item-title"
  }, [_vm._v("1个月")]), _vm._v(" "), _c('div', {
    staticClass: "text-color gray item-desc"
  }, [_vm._v("自动续约，可随时取消")])]), _vm._v(" "), _c('div', {
    staticClass: "item-footer"
  }, [_c('span', {
    staticClass: "text-color orange price"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "font-middle"
  }, [_vm._v("60")])]), _vm._v(" "), _c('span', {
    staticClass: "buy-btn",
    on: {
      "click": function($event) {
        _vm.openActionSheet('month')
      }
    }
  }, [_vm._v("购买")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ds-flex sales-item item-two"
  }, [_c('div', {
    staticClass: "item-header"
  }, [_c('div', {
    staticClass: "text-color item-title"
  }, [_vm._v("\n              12个月\n              "), (!_vm.isTestOldUser) ? _c('span', [_c('img', {
    staticClass: "item-tag",
    attrs: {
      "src": require("../../../assets/images/industry-version/sale-tag@2x.png"),
      "alt": ""
    }
  })]) : _c('span', [_c('img', {
    staticClass: "item-old-tag",
    attrs: {
      "src": require("../../../assets/images/industry-version/old@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-color gray item-desc"
  }, [_vm._v("赚钱的实体店都在用")])]), _vm._v(" "), _c('div', {
    staticClass: "item-footer"
  }, [_c('span', {
    staticClass: "text-color gray oriPrice"
  }, [_vm._v("￥" + _vm._s(_vm.priceObj.oriPrice))]), _vm._v(" "), _c('span', {
    staticClass: "text-color orange price"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "font-middle"
  }, [_vm._v(_vm._s(_vm.priceObj.salePrice))])]), _vm._v(" "), _c('span', {
    staticClass: "buy-btn",
    on: {
      "click": function($event) {
        _vm.openActionSheet('year')
      }
    }
  }, [_vm._v("购买")])])])]), _vm._v(" "), _c('c-images', {
    attrs: {
      "img-items": _vm.images
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-mask",
    on: {
      "click": _vm.openProtocol
    }
  }, [_c('div', {
    staticClass: "overlay-mask-one"
  })])], 1)]), _vm._v(" "), _c('c-footer', {
    staticClass: "footer-shadow"
  }, [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.openActionSheet('year')
      }
    }
  }, [_c('div', [_vm._v("立即购买")])])], 1), _vm._v(" "), _c('c-action-sheet', {
    attrs: {
      "visible": _vm.actionsheetShow
    },
    on: {
      "update:visible": function($event) {
        _vm.actionsheetShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeActionSheet
    }
  }, [_c('i', {
    staticClass: "s-icon-close"
  })]), _vm._v(" "), _c('div', {
    slot: "menu"
  }, [_c('div', {
    staticClass: "industry-wrap"
  }, [_c('industry-modal', {
    attrs: {
      "default-type": _vm.goodsBuyType,
      "price-obj": _vm.priceObj,
      "version-entity": _vm.industyEntity
    },
    on: {
      "update:defaultType": function($event) {
        _vm.goodsBuyType = $event
      },
      "update:priceObj": function($event) {
        _vm.priceObj = $event
      },
      "pay": _vm.buy
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c83fde7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/industry-version/index.vue
// module id = 1023
// module chunks = 2